import {HTMLProps} from 'react';
import EventMaxWidthV4 from './EventMaxWidthV4';
import EllipsisText from '../../common/component/EllipsisText';
import {REGION} from '../../common/constant';
import {IModuleSectionV4} from '../type';

interface IProps extends HTMLProps<HTMLDivElement>, IModuleSectionV4 {
  innerClassName?: string;
}

export default function ModuleSectionV4({
  section,
  className,
  innerClassName,
  children,
  // 각 모듈에 data-module-type 입력하는 이유는
  // DOM 조작시 어떤 모듈인지 파악하기 위해 입력하고 있음
  ...rest
}: IProps) {
  const {title, description} = section ?? {};
  const isKorea = REGION === 'kor';

  return (
    <EventMaxWidthV4
      className={cn('flex flex-col gap-y-12', className)}
      {...rest}
    >
      {(title || description) && (
        <div
          className="max-w-[284px] flex flex-col gap-y-8 overflow-hidden"
          data-testid="text-wrapper-box"
        >
          {title && (
            <EllipsisText
              line={isKorea ? 1 : 2}
              className={cn(
                's16-bold-white tracking-[-0.4px] max-w-[284px]',
                isKorea ? 'leading-20' : 'leading-24'
              )}
            >
              {title}
            </EllipsisText>
          )}
          {description && (
            <EllipsisText
              line={3}
              className="s13-regular-white leading-19 tracking-[-0.4px] max-w-[284px] opacity-80"
            >
              {description}
            </EllipsisText>
          )}
        </div>
      )}
      {/* gap-y 스타일 적용을 위해 div 로 래핑 */}
      <div className={innerClassName}>{children}</div>
    </EventMaxWidthV4>
  );
}
